import { render } from "./form-tree.vue?vue&type=template&id=c57fcb2c"
import script from "./form-tree.vue?vue&type=script&lang=js"
export * from "./form-tree.vue?vue&type=script&lang=js"

import "./form-tree.vue?vue&type=style&index=0&id=c57fcb2c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__